import { BaseCard } from './BaseCard'
import { Select } from '@/components'
import { APIClient } from '@/services'
import { RenderItemProps } from '../types'
import { useProfilePrompt } from '../../useProfilePrompt'

export const CountryCard = ({ item }: RenderItemProps) => {
  const { options } = APIClient.Session.useSession()
  
  const prompt = useProfilePrompt(item)

  return (
    <BaseCard prompt={prompt}>
      <Select
        {...prompt.form.register('country')}
        options={options?.country ?? []}
        searchable
        arrowIconName='chevron-right'
        placeholder='Select your country'
        variants={['noError', 'prompt']}
        onMenuOpen={() => BaseCard.setOpenPortal(prompt, true)}
        onMenuClose={() => BaseCard.setOpenPortal(prompt, false)}
      />
    </BaseCard>
  )
}
